
import { Vue, Component, Ref, Prop, Emit, Watch } from "vue-property-decorator";
import E from "wangeditor";
@Component({
  name: "Editor",
})
export default class Editor extends Vue {
  @Ref("editor") editorRef: any;

  @Prop()
  value!: string;

  @Prop()
  disabled!: boolean;

  @Emit("input")
  handle(newHtml: string) {
    return newHtml;
  }

  @Watch("value")
  watchValue(val: string) {
    // 解决光标跳动到最后
    if (this.value !== this.editor.txt.html()) {
      this.editor.txt.html(val);
    }
  }

  @Watch("disabled")
  wathcDisabled(value: boolean) {
    value ? this.editor.disable() : this.editor.enable();
  }

  private editor: any = null;

  mounted() {

    const editor = new E(this.editorRef);
    // 配置 onchange 回调函数，将数据同步到 vue 中
    editor.config.onchange = (newHtml: string) => {
      console.log("newHtml:", newHtml);
      this.handle(newHtml);
    };

    editor.config.uploadImgShowBase64 = true;
    // editor.config.uploadImgMaxSize = 1 * 1024 * 1024; // 5M
     // 配置服务器端地址 upload:上传图片地址 //http://120.79.9.222:18900 http://localhost:9000
    editor.config.uploadImgServer = 'http://120.79.9.222:18900/qy/boss' + '/file/common/upload'; // 这是服务器端上传图片的接口路径
    editor.config.uploadFileName = "file"; // 后端接受上传文件的参数名
    editor.config.uploadImgHeaders = {
        Authorization: this.$Cookies.get("vue_admin_token"),
    }; // 设置请求头
    editor.config.customUploadImg = function(files:any, insertImgFn:any){

      let tempFile = files[0];

      const reader = new FileReader();
      reader.readAsDataURL(tempFile);
      reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result as string;
          img.onload = () => {
            // 默认设置压缩后的图片最大宽度为800px
            const maxWidth = 700;
            // 默认设置压缩后的图片质量为0.8
            const quality = 0.8;
                
            // 创建canvas对象用于绘制压缩后的图片
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
                
            // 计算压缩后的图片宽度和高度
            const ratio = img.width / img.height;
            let width = maxWidth;
            let height = width / ratio;
                
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width,height);
            canvas.toBlob((blob) => {
              const compressedFile = new File([blob], tempFile.name, { type: tempFile.type, lastModified: Date.now() });

              const formData = new FormData()
              formData.append('file',compressedFile)
              Vue.prototype.$http.post("file/common/upload",formData,{
              headers: {
                    'Content-Type': 'multipart/form-data'
                 }
              }).then((res: any) =>{

                if(res.data.code == 200) {

                  insertImgFn(res.data.data) // 插入图片
                }

              });   

            }, tempFile.type);
          };
      }        

    }

    // 创建编辑器
    editor.create();
    editor.txt.html(this.value); // 重新设置编辑器内容
    // this.value ? editor.disable() : editor.enable();
    this.editor = editor;
  }

  beforeDestroy() {
    // 调用销毁 API 对当前编辑器实例进行销毁
    this.editor.destroy();
    this.editor = null;
  }

  methods:{
    
  }

}
